import useInfiniteScroll from "react-infinite-scroll-hook";
import { useTranslations } from "use-intl";
import { useTripBookings } from "@/app/lib/hooks/useTripBookings";
import Loader from "../../AnimatedLoader";
import PageLoader from "../../PageLoader";
import { TripBookingCard } from "./TripBookingCard";

export const MyTripsList = ({
  onReservationClick,
}: {
  onReservationClick: (reservationId: string) => void;
}) => {
  const t = useTranslations();
  const { data, isLoading, isFetching, isError, hasNextPage, fetchNextPage } =
    useTripBookings();
  const [sentryRef] = useInfiniteScroll({
    loading: isFetching,
    hasNextPage,
    onLoadMore: () => {
      fetchNextPage();
    },
    disabled: isError,
    rootMargin: "0px 0px 40px 0px",
  });

  if (isLoading) {
    return (
      <PageLoader>
        <Loader icon="buildings" />
      </PageLoader>
    );
  }

  const bookingCount = data?.pages?.[0]?.data?.count;
  const bookings =
    data?.pages?.flatMap((page) => page.data.packageBookings) || [];

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        {/* a spacer to align the booking count text */}
        <div />

        {bookingCount ? (
          <div className="text-md font-medium">
            {t("hotels.bookedHotels", { bookingCount })}
          </div>
        ) : null}
      </div>

      {bookings.length > 0 ? (
        <ul aria-label={t("hotels.bookedHotelsList")} className="space-y-2">
          {bookings.map((booking) => (
            <li key={booking.id}>
              <TripBookingCard
                booking={booking}
                onClick={() => onReservationClick(booking.id)}
              />
            </li>
          ))}
        </ul>
      ) : null}

      {isFetching || hasNextPage ? (
        <div
          className="flex items-center justify-center py-4"
          ref={sentryRef}
          aria-hidden={!isFetching}
        >
          <Loader icon="buildings" />
        </div>
      ) : (
        <div className="flex items-center justify-center p-8 text-text-tertiary">
          {t("hotels.noMoreResults")}
        </div>
      )}
    </>
  );
};
